import { Theme } from "@/shared/common/enums";
import { createSlice } from "@reduxjs/toolkit";

interface InitialState {
  theme: string;
}

const initialState: InitialState = {
  theme: localStorage.getItem(Theme.Theme) || Theme.Light,
};

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.theme = state.theme === Theme.Light ? Theme.Dark : Theme.Light;
      localStorage.setItem(Theme.Theme, state.theme);
      document.documentElement.setAttribute(Theme.DataTheme, state.theme);
    },
  },
});

export const { toggleTheme } = themeSlice.actions;
export default themeSlice.reducer;
